import { SxProps, Theme } from '@mui/material';

/**
 * One row of the dialog's body: a group of buttons, an alert, or the purchase select.
 *
 * Wraps, because the scheduled case shows three buttons side by side and a narrow phone
 * has room for two.
 */
export const detailRowStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 1,
    flexWrap: 'wrap',
    mt: 2,
};
